const PARTS_LENGTH = 2;
export default function getCookie(name: string): any {
    const prefix = `${name}=`;
    const cookieString = `; ${document.cookie}`;
    const parts = cookieString.split(`; ${prefix}`);

    if (parts.length === PARTS_LENGTH) {
        const cookieValue = parts.pop()!.split(';').shift()!;

        const decodedValue = decodeURIComponent(cookieValue);

        try {
            return JSON.parse(decodedValue);
        } catch (e) {
            return decodedValue;
        }
    }
    return null;
}
